(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collections-list-manual"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('box-fade-carousel')) {
    customElements.define('box-fade-carousel', class extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.yirinatek-box-fade__slide'));
        this.current = 0;
        this.delay = Number(this.dataset.delay) || 0;
        this.offset = Number(this.dataset.offset) || 0;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.start = this.start.bind(this);
        this.stop = this.stop.bind(this);
        this.handleVisibility = this.handleVisibility.bind(this);
        this.addEventListener('mouseenter', this.stop);
        this.addEventListener('mouseleave', this.start);
        this.addEventListener('focusin', this.stop);
        this.addEventListener('focusout', this.start);
        document.addEventListener('visibilitychange', this.handleVisibility);
        this.start();
      }

      disconnectedCallback() {
        this.stop();
        document.removeEventListener('visibilitychange', this.handleVisibility);
      }

      show(index) {
        this.current = index % this.slides.length;
        this.slides.forEach((slide, slideIndex) => {
          const active = slideIndex === this.current;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
        });
      }

      start() {
        if (this.reducedMotion || this.delay <= 0 || this.slides.length < 2 || document.hidden) return;
        this.stop();
        this.startTimer = window.setTimeout(() => {
          this.show(this.current + 1);
          this.timer = window.setInterval(() => this.show(this.current + 1), this.delay);
        }, this.delay + this.offset);
      }

      stop() {
        window.clearTimeout(this.startTimer);
        window.clearInterval(this.timer);
        this.startTimer = null;
        this.timer = null;
      }

      handleVisibility() {
        if (document.hidden) this.stop();
        else this.start();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
